<template>
  <Dialog :common-dialog="dialog" :dialog-width="dialogWidth">
    <template v-slot:title>
      <v-layout class="px-4">
        <v-flex> Select an Entity </v-flex>
        <v-flex class="text-right">
          <v-btn
            style="height: 32px !important"
            class="custom-bold-button"
            depressed
            icon
            :disabled="loading"
            v-on:click="$emit('close', true)"
            color="red white--text"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </template>

    <template v-slot:body>
      <div class="px-4 w-100">
        <!-- <label for="entity-search" class="font-weight-600">
          Which entity would you like to select this for?
        </label>
        <div class="d-flex mb-2">
          <v-text-field
            id="entity-search"
            v-model="search"
            class="line-item-header-text px-0 v-slot-m-none"
            placeholder="Search Entities..."
            dense
            filled
            solo
            flat
            color="cyan"
            :loading="loading"
            :disabled="loading"
            style="max-width: 400px"
            v-on:keyup.enter="getEntities()"
          />
          <v-btn
            v-on:click="getEntities()"
            :loading="loading"
            :disabled="loading"
            style="height: 32px !important"
            class="custom-bold-button ml-2"
            depressed
            color="cyan white--text"
          >
            Search
          </v-btn>
        </div> -->

        <div
          class="custom-border-top"
          style="max-height: calc(100vh - 300px); overflow-y: scroll"
        >
          <div v-if="filteredList.length">
            <div
                v-for="(row, index) in filteredList"
                :key="`entity-list-key-${index}`"
                class="cursor-pointer hover-grey d-flex align-center custom-border-bottom py-3 px-3"
                :class="{ 'cyan lighten-5': selectedEntityId === row.id }"
                v-on:click="selectEntity(row)"
            >
                <div style="width: 80%">
                <p class="m-0 font-weight-600 font-size-16 d-flex align-center">
                    <v-icon class="chip-custom-blue mr-2" small>mdi-office-building-outline</v-icon>
                    {{ row.name }}
                </p>
                <p class="m-0 font-weight-500 font-size-14 mt-1" v-if="row.address">
                    <v-icon class="chip-custom-blue mr-2" small>mdi-map-marker-outline</v-icon>
                    {{ row.address }}
                </p>
                </div>
                <div style="width: 20%" class="text-right" v-if="selectedEntityId === row.id">
                <v-icon color="cyan">mdi-check-circle</v-icon>
                </div>
            </div>
            </div>

            <div v-else class="d-flex justify-center align-center py-3 font-weight-500">
            <img width="40px" :src="$assetURL('media/error/empty.png')" class="row-not-found-image mr-2" />
            Uhh... There are no entities at the moment.
            </div>
        </div>
      </div>
    </template>

    <template v-slot:action>
      <v-btn
        v-on:click="$emit('close', true)"
        class="mx-2 custom-grey-border custom-bold-button"
        :disabled="loading"
      >
        Close
      </v-btn>
    </template>
  </Dialog>
</template>

<script>
import Dialog from "@/view/pages/partials/Dialog.vue";

export default {
  name: "entity-select",

  props: {
    dialog: { type: Boolean, default: false },
    selectedEntityId: { type: Number, default: null },
    entityList: { type: Array, default: () => [] },
    loading:{ type: Boolean, default: false },
  },

  components: { Dialog },

  data() {
    return {
      // search: null,
    };
  },

  computed: {
    dialogWidth() {
      return this.lodash.toSafeInteger((document.body.clientWidth / 100) * 50);
    },
    filteredList() {
      if (!this.search) return this.entityList;
      const q = this.search.toLowerCase();
      return this.entityList.filter(e =>
        (e.name && e.name.toLowerCase().includes(q)) ||
        (e.address && e.address.toLowerCase().includes(q))
      );
    },
  },

  methods: {
    selectEntity(row) {
      this.$emit("selected", row);
      this.$emit("close", true);
    },
      // getEntities() {
      //   this.$emit("search", this.search);
      // },
  },
};
</script>